import React, { ReactNode } from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';

interface InfoBoxProps {
  children: ReactNode;
  icon?: ReactNode;
  sx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
}

const InfoBox: React.FC<InfoBoxProps> = ({
  children,
  icon,
  sx = {},
  iconSx = {},
  contentSx = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        backgroundColor: '#f7f7f8',
        borderRadius: 1,
        padding: 2,
        marginBottom: 3,
        marginTop: 2,
        ...sx,
      }}
    >
      {icon ? (
        <Box sx={{ color: 'text.secondary', mt: 0.2, mr: 1.5, flexShrink: 0, ...iconSx }}>
          {icon}
        </Box>
      ) : (
        <InfoIcon
          fontSize='small'
          sx={{
            color: 'text.secondary',
            mt: 0.2,
            mr: 1.5,
            flexShrink: 0,
            ...iconSx,
          }}
        />
      )}

      {typeof children === 'string' ? (
        <Typography variant='body2' color='text.secondary' sx={contentSx}>
          {children}
        </Typography>
      ) : (
        children
      )}
    </Box>
  );
};

export default InfoBox;
